import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ete',
  templateUrl: './ete.component.html',
  styleUrls: ['./ete.component.scss']
})
export class EteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
